export default "__VITE_ASSET__Cx03rq6k__"